import { QueryClient } from "@tanstack/react-query";

const STALE_SECONDS = 180;

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: STALE_SECONDS * 1000,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            throwOnError: true,
        }
    }
});

export default queryClient;
